module.exports = __webpack_public_path__ + "static/media/Anuujin.b5c9a081.jpg";